/* ============================
   TERMS AND CONDITIONS (EN)
   ============================ */

export const terms_en = `
TERMS AND CONDITIONS OF SERVICE
Last Updated: December 12, 2025

IMPORTANT – PLEASE READ CAREFULLY:
By clicking "I Agree," purchasing a report, or using the platform operated by
Reignite.Spirit Ltd (the "Service"), you ("You" or "User") agree to be bound by
these Terms and Conditions ("Terms"). If you do not agree to these Terms,
you must not use this Service.

1. NATURE OF THE SERVICE (AI DISCLAIMER)

1.1 Artificial Intelligence:
You acknowledge that the Service utilizes advanced Artificial Intelligence (AI)
and Large Language Models (LLMs) to generate career strategies.

1.2 No Human Review:
The reports are generated automatically based on your inputs.
They are not reviewed by human career counselors, recruiters, or legal experts.

1.3 Possibility of Error ("Hallucinations"):
AI systems may occasionally generate incorrect or "hallucinated" information,
including non-existent company names or inaccurate salary data.
You agree to independently verify any information provided in the report
before taking action.

2. DISPUTE OF ACCURACY & RIGHT TO CURE

2.1 7-Day Review Period:
If You discover any material factual error or falsity in the report generated by
the Service, You must notify us in writing within seven (7) calendar days of the
report’s delivery ("Notice Period").

2.2 Verification & Remedy:
Upon receipt of such notice, Reignite.Spirit Ltd reserves the right to review the
alleged error. If we determine, in our sole discretion, that the information
provided was materially false or inaccurate, our sole obligation shall be to:

(a) Generate one (1) replacement report at no additional cost; and  
(b) Review and correct the specific information prior to re-sending.

2.3 Waiver:
Failure to notify us within the Notice Period constitutes your full acceptance
of the report as accurate and complete, and You waive any further right to
dispute the content.

3. NO GUARANTEES OR WARRANTIES

3.1 No Employment Guarantee:
We do not guarantee that you will secure a job, interview, or career transition
as a result of using this Service.

3.2 "As Is" Basis:
The Service is provided "as is" and "as available" without warranties of any kind,
whether express or implied.

3.3 Not Professional Advice:
The content provided is not financial, legal, or professional recruitment advice.
You assume full responsibility for your career decisions.

4. PAYMENTS, REFUNDS & DATA SECURITY

4.1 Digital Goods:
The Career Pivot Report is a non-tangible digital good.

4.2 No Refunds:
Except as expressly provided in Clause 2.2 above, once the report has been
generated and delivered, all sales are final.

4.3 Payment Gateway & Data Security:
Reignite.Spirit Ltd uses a secure third-party payment processing provider.
We do not store or process your payment information.
We receive only a confirmation token required to trigger report generation.

5. LIMITATION OF LIABILITY

5.1 Liability Cap:
To the maximum extent permitted by law, total liability shall never exceed the
amount you paid for the Service.

5.2 Exclusion of Damages:
We shall not be liable for indirect, incidental, special, consequential, or
punitive damages, including loss of income, employment, or data.

6. INTELLECTUAL PROPERTY

6.1 Ownership:
All AI algorithms, prompts, designs, and methodologies remain the exclusive
property of Reignite.Spirit Ltd.

6.2 License:
You are granted a limited, non-exclusive, non-transferable license to use the
generated PDF report for personal, non-commercial use.

7. DATA PRIVACY & CONSENT

By using the Service, you consent to the processing of your personal data in
accordance with our Privacy Policy.
Your data may be processed by third-party providers including OpenAI,
Google Cloud, and Stripe.

8. GOVERNING LAW AND JURISDICTION

8.1 Governing Law:
These Terms shall be governed by the laws of the Abu Dhabi Global Market (ADGM).

8.2 Jurisdiction:
All disputes shall be subject to the exclusive jurisdiction of the ADGM Courts,
Abu Dhabi, United Arab Emirates.
`;

/* ============================
   PRIVACY POLICY (OPTIONAL)
   ============================ */

export const privacy_en = `
Refer to the official Privacy Policy available on the Reignite.Spirit platform.
`;

/* ============================
   ARABIC (PLACEHOLDERS)
   ============================ */

export const terms_ar = `
سيتم إضافة الشروط والأحكام باللغة العربية لاحقًا.
`;

export const privacy_ar = `
سيتم إضافة سياسة الخصوصية باللغة العربية لاحقًا.
`;
